import { render, staticRenderFns } from "./IdentityChallenge.vue?vue&type=template&id=22cec52a&scoped=true"
import script from "./IdentityChallenge.vue?vue&type=script&lang=ts"
export * from "./IdentityChallenge.vue?vue&type=script&lang=ts"
import style0 from "./IdentityChallenge.vue?vue&type=style&index=0&id=22cec52a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22cec52a",
  null
  
)

export default component.exports